import { MetricCard, useTimeDistance } from "@quortex/front-common"
import { formatBandwidth } from "@/helpers/formatters"

interface EstimatedUsageCardProps {
  estimatedUsage: number
  refetchedAt: Date
  className?: string
}

const EstimatedUsageCard = ({ estimatedUsage, ...props }: EstimatedUsageCardProps) => {
  const timeDistance = useTimeDistance(props.refetchedAt?.toISOString() ?? "")
  return (
    <MetricCard
      hasNoData={!estimatedUsage}
      subtext={props.refetchedAt ? `Updated: ${timeDistance}` : ""}
      title="Estimated usage"
      valueLabel={`${formatBandwidth(estimatedUsage)} Gbps`}
    />
  )
}

export default EstimatedUsageCard
